import ImportHolidayPage from "../../../../component/holidays/add-holidays/ImportHoliday";

function ImportHoliday() {
  return (
    <div className="page-body">
      <ImportHolidayPage />
    </div>
  );
}

export default ImportHoliday;
